module.exports = __webpack_public_path__ + "img/ga.27ed4a37.svg";